<button (click)="onBackClick()"
        class="orange-button"
        id="back-button"
        *ngIf="shouldShow"
        [ngClass]="{'d-xl-none': !forceShow}"
>
  <fa-icon icon="arrow-left"></fa-icon>
</button>